import { render, staticRenderFns } from "./xskPopup.vue?vue&type=template&id=6458addd&scoped=true&"
import script from "./xskPopup.vue?vue&type=script&lang=js&"
export * from "./xskPopup.vue?vue&type=script&lang=js&"
import style0 from "./xskPopup.vue?vue&type=style&index=0&id=6458addd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6458addd",
  null
  
)

export default component.exports